import React from "react";
import { wire } from "react-hot-wire";
import classnames from "classnames";

import List from "@material-ui/core/List";

import IconViewList from "@material-ui/icons/ViewList";
import IconDynamicFeed from "@material-ui/icons/DynamicFeed";
import IconBuild from "@material-ui/icons/Build";

import { UserService } from "services/user/User.service";
import { DrawerService } from "services/drawer/Drawer.service";

import SideNavItem from "./SideNavItem";

const sideNavItems = [
  {
    name: "Application",
    Icon: IconViewList,
    items: [
      {
        name: "Active list",
        link: "/application/list/active"
      },
      {
        name: "Archived list",
        link: "/application/list/archived"
      }
    ]
  },
  {
    name: "Prize",
    Icon: IconDynamicFeed,
    items: [
      {
        name: "Prize list",
        link: "/prize/list"
      },
      {
        name: "Category list",
        link: "/prize/category/list"
      },
      {
        name: "Supplier list",
        link: "/prize/supplier/list"
      },
      {
        name: "Order list",
        link: "/prize/order/list"
      }
    ]
  },
  {
    name: "Job",
    Icon: IconBuild,
    items: [
      {
        name: "Job list",
        link: "/job/list"
      }
    ]
  }
];

function AdminNav() {
  return (
    <List component="nav" style={{ width: "100%" }} disablePadding>
      {sideNavItems.map((item, index) => (
        <SideNavItem {...item} key={index} />
      ))}
    </List>
  );
}

function SideNav({
  isOpen,
  userService: { user }
}: {
  isOpen: boolean;
  userService: UserService;
  drawerService: DrawerService;
}) {
  return (
    <div
      className={classnames("sideNav", {
        isOpen
      })}
    >
      {user!.isAdmin() && <AdminNav />}
    </div>
  );
}

export default wire(["userService"], SideNav);
